import React, { useContext, useEffect } from "react";
import { Route, Navigate } from "react-router-dom";
import Home from "../layouts/home/index";
import { API } from "@aws-amplify/api";
import { OffLineAPI } from "../offline-auth/api";
import { PayLoadCtx, RoleCtx } from "../lib/context";

const _API = process.env.REACT_APP_isOffline === "true" ? OffLineAPI : API;

const Cookies = require("js-cookie");

function querystring(name, url = window.location.href) {
    name = name.replace(/[[]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
    const results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const PublicRoute = ({ children }) => {
    const { payload } = useContext(PayLoadCtx);
    const { role } = useContext(RoleCtx);
    const referrer = querystring("ref");
    const parsedUrl = new URL(window.location.href);
    useEffect(() => {
        // if (referrer) {
        //     window.Cookies.set('referrer', referrer, { expires: 25, path: '' });

        const ref_coc = Cookies.get("inclinicreferrer");
        if (referrer && (ref_coc === undefined || (ref_coc && ref_coc !== referrer))) {
            // window.Cookies.set("inclinicreferrer", referrer, { expires: 1, path: `/${parsedUrl.hostname.split('.')[0]}`, secure: true, sameSite: 'strict', httpOnly: true });
            Cookies.set("inclinicreferrer", referrer, {
                domain: parsedUrl.hostname,
                expires: 1,
                path: parsedUrl.pathname,
                secure: true,
                sameSite: "Strict",
                httpOnly: false,
            });

            let body = {
                // referral_url : window.location.href,
                userId: referrer,
                productCode: "INCLINIC",
            };
            _API.post("inaffiliateUser", "/referrerclicks", { body })
                .then((res) => {
                    // console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [referrer]);

    if (payload) {
        if (role === "D") {
            return <Navigate to="/doctor-appointments" replace />;
        } else if (role === "P") {
            return <Navigate to="/patient-dashboard" replace />;
        } else if (role === "C") {
            return <Navigate to="/clinic-dashboard" replace />;
        } else if (role === "CA") {
            return <Navigate to="/admin-dashboard" replace />;
        } else if (role === "SA") {
            return <Navigate to="/dashboard" replace />;
        } else {
            return <Navigate to={`/?redirect=${window.location.pathname}${window.location.search}`} replace />;
        }
    }

    return <Home>{children}</Home>;
};

export default PublicRoute;
